import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { BoxProps, ButtonProps, GridProps } from '@mui/material';

export type FileUploaderCustomFnProps = {
  disabledCondition?: boolean;
  onHandleButtonClick?: () => void;
  dragActive?: boolean;
  errors?: UseFormReturn['formState']['errors'];
  name?: string;
  title?: string;
};
export type FileUploaderProps = {
  customUploadButton?: (props: FileUploaderCustomFnProps) => React.ReactNode;
  acceptType?: string;
  defaultButtonProps?: ButtonProps;
  defaultButtonText?: React.ReactNode;
  buttonIconProps?: BoxProps;
  itemProps?: GridProps;
  enableDrop?: boolean;
  enablePreview?: boolean;
  onChange?: (value: File[]) => void;
  disableDefaultIcon?: boolean;
  value?: File[];
  iconSize?: 'small' | 'inherit' | 'medium' | 'large';
  allowMultiple?: boolean;
  uploadLimitSize?: number;
};

export type CustomUploadButtonProps = {
  onClick: () => void;
  disabled: boolean;
  className: string;
};
